import keys from '@debbie/common/dist/cache/keys.js';
import { CaseStatus } from '@debbie/common/dist/cases/index.js';
import { getSubscriptionStatus } from '@debbie/common/dist/cosmoV2/utils/providers.js';
import { getRKIRegistrations } from '@debbie/common/dist/customers/helpers.js';
import { CompanyStarCycle, PrivateStarCycle, } from '@debbie/common/dist/customers/index.js';
import { Site } from '@debbie/common/dist/index.js';
import { isCaseworker } from '@debbie/common/dist/permissions/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as casesAPI from '@debbie/cortex/dist/api/cases.js';
import * as customersAPI from '@debbie/cortex/dist/api/customers.js';
import { casesEntity, ensureCaseLoaded, } from '@debbie/cortex/dist/cases/index.js';
import { useCosmoV2ProviderSubscriptions } from '@debbie/cortex/dist/cosmoV2/index.js';
import { useCustomerRelatedCases } from '@debbie/cortex/dist/customers-related-cases/index.js';
import { customersEntity, ensureCustomerLoaded, } from '@debbie/cortex/dist/customers/index.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import { useRole } from '@debbie/cortex/dist/me/index.js';
import q from '@debbie/cortex/dist/query.js';
import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import { errorNotification } from '../../utils/errors.js';
import CasesOnCustomer from '../Customers/CasesOnCustomer.js';
import { Row } from '../Grid/index.js';
import { Check, Crosshair, X } from '../Icons/index.js';
import Loading from '../Loading.js';
import Panel from '../Panel.js';
import Tooltip from '../Tooltip.js';
import CasesRelatedToCustomer from './CasesRelatedToCustomer.js';
import UserInfo from './UserInfo.js';
const UserOnCustomer = (props) => {
    const { user, customer } = props;
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const meRole = useRole();
    const [hovered, setHovered] = useState(false);
    const [showTooltipOnTop, setShowTooltipOnTop] = useState(false);
    const ref = useRef(null);
    const onMouseIn = () => setHovered(true);
    const onMouseOut = () => setHovered(false);
    const { name, companyStatus, movedAbroad, companies, status, addressProtection, dissolvedStatuses, guardian, } = user.details;
    const rkiOpenRegistrations = getRKIRegistrations(user.details)?.filter((r) => r.Fundament !== 'Intet');
    const isMeCaseWorker = meRole && isCaseworker(meRole);
    const isContact = user.userOnCustomerId === props.case?.userOnCustomerId;
    const canCheckUser = !isContact;
    const loader = useCosmoV2ProviderSubscriptions(user.userId);
    const providerSubscriptions = h.hasData(loader) ? loader.data : null;
    const isSubscribedToCosmo = providerSubscriptions && providerSubscriptions.length > 0;
    const providerSubscriptionStatus = providerSubscriptions
        ? getSubscriptionStatus(providerSubscriptions)
        : null;
    const aksError = providerSubscriptionStatus?.AKS?.sub.error;
    const setContactMutation = useMutation(async () => {
        if (props.case) {
            await casesAPI.patch(props.case.caseId, {
                userOnCustomerId: user.userOnCustomerId,
            });
            q.invalidate(keys.write.modify(casesEntity, props.case.caseId));
            await ensureCaseLoaded(props.case.caseId);
        }
        // Update default contact on customer, if there is only one active case
        if (customer.cases.filter((_case) => [CaseStatus.PENDING, CaseStatus.VERIFIED].includes(_case.status)).length === 1) {
            await customersAPI.patchUser(customer.customerId, user.userId, {
                contact: !isContact,
            });
            q.invalidate(keys.write.modify(customersEntity, customer.customerId));
            await ensureCustomerLoaded(customer.customerId);
        }
    }, {
        onError: (err) => {
            errorNotification(lang, err, 'update', lang.errorEntities.contact);
        },
    });
    const deleteUserMutation = useMutation(async () => {
        await customersAPI.deleteUser(customer.customerId, user.userId);
        q.invalidate(keys.write.modify(customersEntity, customer.customerId));
        await ensureCustomerLoaded(customer.customerId);
    }, {
        onError: (err) => {
            errorNotification(lang, err, 'delete', lang.errorEntities.party);
        },
    });
    return (React.createElement(UserPreviewStyled, { onMouseEnter: onMouseIn, onMouseLeave: onMouseOut, onClick: () => {
            if (props.onClick) {
                props.onClick(user);
            }
        }, selected: props.selected, subscribedToCosmo: isSubscribedToCosmo || false, ref: ref, open: hovered, showTooltipOnTop: showTooltipOnTop },
        props.case && (React.createElement(ContactCheckmark, null,
            React.createElement("div", { className: `checkmark ${isContact && 'checked'} ${isMeCaseWorker ? '' : 'not-editable'}`, style: { cursor: canCheckUser ? 'pointer' : 'default' }, onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (site === Site.Caseworker && canCheckUser) {
                        setContactMutation.mutate();
                    }
                } }, setContactMutation.isLoading ? (React.createElement(Loading, { width: "10px", style: { margin: '2px 2px 3px 1px' } })) : isContact ? (React.createElement(Check, null)) : (React.createElement(Crosshair, null))))),
        isMeCaseWorker && (React.createElement(DeleteUser, { className: "delete-user", onClick: (e) => {
                e.preventDefault();
                e.stopPropagation();
                if (confirm(lang.debtors.confirmDeleteUserFromCustomer)) {
                    deleteUserMutation.mutate();
                }
            } }, deleteUserMutation.isLoading ? (React.createElement(Loading, { width: "10px", style: { margin: '2px 2px 3px 1px' } })) : (React.createElement(X, null)))),
        React.createElement("div", { className: "debtor-name" },
            React.createElement(Badges, null,
                rkiOpenRegistrations && !!rkiOpenRegistrations.length && (React.createElement(BadgeStyled, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.debtors.rkiRegistrations },
                    "RKI (",
                    rkiOpenRegistrations.length,
                    ")")),
                React.createElement(OtherCasesBadges, { customer: customer, user: props.user }),
                companyStatus &&
                    !status &&
                    !['aktiv', 'normal'].includes(companyStatus.toLowerCase()) && (React.createElement(BadgeStyled, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.debtors.companyStatus }, companyStatus)),
                customer.isCompany &&
                    status?.stage &&
                    status.stage !== CompanyStarCycle.Active && (React.createElement(BadgeStyled, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.debtors.companyStatus }, lang.debtors.status[status.stage])),
                movedAbroad &&
                    movedAbroad[0] &&
                    status?.stage === PrivateStarCycle.GoneAway && (React.createElement(BadgeStyled, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": `${lang.debtors.movedTo} ${movedAbroad.join(', ')}` }, lang.debtors.movedAbroad)),
                guardian?.status && (React.createElement(BadgeStyled, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.debtors.guardian }, lang.debtors.guardian)),
                dissolvedStatuses && dissolvedStatuses.status && (React.createElement(BadgeStyled, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": `${lang.debtors.dissolutionStatus} :  ${
                    // @ts-ignore
                    lang.debtors.dissolvedStatus[dissolvedStatuses.status]}` }, 
                // @ts-ignore
                lang.debtors.dissolvedStatus[dissolvedStatuses.status])),
                companies && companies[0] && (React.createElement(WarningBadge, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": `Owns ${companies
                        .map((company) => company.name)
                        .join(', ')}` }, companies.length > 1
                    ? lang.debtors.ownsCompanies
                    : lang.debtors.ownsCompany)),
                aksError && (React.createElement(DangerousBadge, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.debtors.aksFailed }, "AKS!")),
                !customer.isCompany &&
                    status &&
                    !movedAbroad &&
                    status.stage !== 'ACTIVE' &&
                    lang.debtors.status[status.stage] && (React.createElement(DangerousBadge, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.debtors.cprStatus }, lang.debtors.status[status.stage])),
                addressProtection && (React.createElement(DangerousBadge, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.debtors.addressProtection }, lang.debtors.addressProtectionShort))),
            React.createElement("div", { className: "debtor-icon" }, (name || '-').slice(0, 1)),
            React.createElement("div", { style: {
                    display: 'inline-block',
                    verticalAlign: 'bottom',
                    marginBottom: '2px',
                } },
                React.createElement("div", { style: {
                        fontSize: '.7em',
                        fontWeight: 900,
                    } },
                    lang.roles[user.relation],
                    user.details.type &&
                        ` - ${lang.alternativeContactTypes[user.details.type]}`,
                    user.details.description && (React.createElement("span", { style: { color: THEME.COLOR_ACCENT } },
                        ' ',
                        "- ",
                        user.details.description))),
                React.createElement("div", null,
                    React.createElement("span", null, name),
                    React.createElement("span", { className: "debtor-id" },
                        "@",
                        user.id)))),
        hovered && !props.noPreview && (React.createElement(Tooltip, { tooltipToLeft: props.tooltipToLeft, parentRef: ref, setShowTooltipOnTop: setShowTooltipOnTop, shouldShowOnTop: showTooltipOnTop },
            React.createElement(Row, null,
                React.createElement(Panel, null,
                    React.createElement(UserInfo, { customer: customer, user: user })),
                React.createElement(Panel, { header: lang.customers.casesOnCustomer },
                    React.createElement(CasesOnCustomer, { customer: customer })),
                React.createElement(Panel, { header: lang.customers.relatedCases },
                    React.createElement("p", null, lang.customers.casesRelatedToCustomerDescription),
                    React.createElement(CasesRelatedToCustomer, { customerId: customer.customerId })))))));
};
export default UserOnCustomer;
const OtherCasesBadges = (props) => {
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const relatedCasesLoadable = useCustomerRelatedCases(props.customer.customerId);
    const relatedCases = h.hasData(relatedCasesLoadable)
        ? relatedCasesLoadable.data.filter((c) => c.userOnCustomerId === props.user.userOnCustomerId)
        : null;
    const relatedVerifiedCases = relatedCases?.filter((_case) => _case.caseStatus === CaseStatus.VERIFIED);
    const verifiedCasesOnCustomer = props.customer.cases?.filter((_case) => _case.status === CaseStatus.VERIFIED);
    return (React.createElement(React.Fragment, null,
        relatedCases && relatedCases.length > 0 && (React.createElement(WarningBadge, { otherBackgroundColor: !relatedVerifiedCases?.length ? THEME.COLOR_GREY : undefined, "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.debtors.relatedCasesDescription, onClick: (e) => {
                if (site === Site.Caseworker) {
                    e.stopPropagation();
                    e.preventDefault();
                    c.redirect.redirect(`/creditors/${props.customer.creditorId}/customers/${props.customer.customerId}/cases`);
                }
            } },
            relatedVerifiedCases?.length,
            " / ",
            relatedCases?.length || 0,
            ' ',
            lang.debtors.relatedCases)),
        props.customer.cases.length > 1 && (React.createElement(WarningBadge, { otherBackgroundColor: !verifiedCasesOnCustomer?.length ? THEME.COLOR_GREY : undefined, "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.debtors.otherCasesDescription, onClick: (e) => {
                if (site === Site.Caseworker) {
                    e.stopPropagation();
                    e.preventDefault();
                    c.redirect.redirect(`/creditors/${props.customer.creditorId}/customers/${props.customer.customerId}/cases`);
                }
            } },
            verifiedCasesOnCustomer?.length,
            " /",
            ' ',
            props.customer.cases?.length || 0,
            " ",
            lang.debtors.otherCases))));
};
const Badges = styled.div `
  position: absolute;
  top: -8px;
  right: 15px;
  color: ${THEME.COLOR_SECONDARY};
  font-size: 0.7em;
  font-weight: bold;
`;
const UserPreviewStyled = styled.div `
  position: relative;
  padding: 6px 12px 6px 6px;
  background-color: ${THEME.FILL};
  margin-top: 10px;
  border-radius: 3px;
  cursor: pointer;

  ${(props) => props.open
    ? props.showTooltipOnTop
        ? `
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      `
        : `
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      `
    : ''}

  div.debtor-icon {
    display: inline-block;
    flex-basis: 30px;
    flex-grow: 0;
    flex-shrink: 0;
    border-radius: 4px;
    background-color: ${(props) => props.subscribedToCosmo ? THEME.COLOR_ACCENT : THEME.NEUTRAL};
    margin-right: 7px;
    color: ${THEME.COLOR_SECONDARY};
    padding: 7px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  div.debtor-name {
    font-weight: bold;
    font-size: 0.8em;
    font-weight: initial;
    display: flex;
  }

  span.debtor-id {
    margin-left: 4px;
    font-weight: bold;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  &:hover .delete-user {
    opacity: 1;
  }

  &::before {
    content: ' ';
    position: absolute;
    height: calc(100% + 6px);
    width: calc(100% + 6px);
    left: -3px;
    top: -3px;
    border-radius: 5px;
    ${(props) => props.selected ? `border: 2px solid ${THEME.COLOR_ACCENT};` : ''}
  }

  ${(props) => props.selected
    ? `
      &::after {
        content: '\\25ba';
        position: absolute;
        font-size: 0.7em;
        color: #7568f6;
        right: -10px;
        top: calc(50% - 7px);
        }
      `
    : ''}
`;
const badgeCss = `
  border-radius: 8px;
  background-color: ${THEME.DANGEROUS};
  padding: 0.2em 0.5em;
  float: right;
  margin-left: 5px;
  `;
const BadgeStyled = styled.div `
  ${badgeCss}
`;
const WarningBadge = styled.div `
  ${badgeCss}
  background-color: ${(props) => props.otherBackgroundColor ? props.otherBackgroundColor : THEME.WARNING};
`;
const DangerousBadge = styled.div `
  ${badgeCss}
  background-color: ${THEME.DANGEROUS};
`;
const ContactCheckmark = styled.div `
  position: relative;
  .checkmark {
    background-color: ${THEME.BORDER_STRONG};
    width: 14px;
    height: 14px;
    border-radius: 100%;
    position: absolute;
    top: -12px;
    left: -11px;
    color: ${THEME.COLOR_SECONDARY};
    text-align: center;
    cursor: pointer;
    svg {
      height: 10px;
      width: 10px;
      margin: -3px 0px 3px;
    }
    &.not-editable {
      cursor: default;
    }
    &.checked {
      background-color: ${THEME.SUCCESS};
    }
  }
`;
const DeleteUser = styled.div `
  background-color: ${THEME.BORDER_STRONG};
  width: 14px;
  height: 14px;
  border-radius: 100%;
  position: absolute;
  top: -6px;
  right: -4px;
  color: ${THEME.COLOR_GREY};
  text-align: center;
  cursor: pointer;
  opacity: 0;

  svg {
    height: 10px;
    width: 10px;
    margin: -3px 0px 3px;
  }
`;
//# sourceMappingURL=UserOnCustomer.js.map